import { OrganizerSubscriptionSummary } from '../interfaces/organizer-list-item';

/**
 * Formats subscription expiry for display in organizer row.
 * Returns:
 * - activeTo date (YYYY-MM-DD only) when status is ACTIVE
 * - "Истек" when status is EXPIRED
 * - "Нет" when status is NONE or subscriptionSummary is undefined/null
 */
export function formatSubscriptionExpiry(subscriptionSummary?: OrganizerSubscriptionSummary | null): string {
  if (!subscriptionSummary) {
    return 'Нет';
  }

  switch (subscriptionSummary.status) {
    case 'ACTIVE':
      if (!subscriptionSummary.activeTo) {
        return 'Нет';
      }
      return subscriptionSummary.activeTo.split('T')[0];
    case 'EXPIRED':
      return 'Истекла';
    case 'NONE':
      return 'Нет';
    default:
      return 'Нет';
  }
}
